import { isObject } from '@guardian/libs';
import { sendProgressOnUnloadOnce, updateVideoProgress, } from '../video-progress-reporting';
const initMessengerVideoProgressReporting = (register) => {
    register('video-progress', async (specs, ret, iframe) => {
        const adSlot = iframe?.closest('.js-ad-slot');
        if (adSlot &&
            isObject(specs) &&
            'progress' in specs &&
            typeof specs.progress === 'number') {
            void sendProgressOnUnloadOnce();
            updateVideoProgress(adSlot.id, specs.progress);
        }
        return Promise.resolve();
    });
};
export { initMessengerVideoProgressReporting };
